import { ActionTypes } from '../constants/index';

export const getSubscriptionPlan = () => ({
  type: ActionTypes.SUBSCRIPTION_MGMT_REQUEST,
});
